import React from "react";

import Link from "core/Link";
import CollectionList from "./collection-list";

import { LinkContainer } from "../styles";

const Collection = ({ username, collections }) => {
    const linkProps = {
        size: "md",
        styleType: "primary"
    };

    return (
        <React.Fragment>
            <header className="display-flex col-xs-12">
                <h3 className="ui_collections">Icon Sets</h3>
                <LinkContainer>
                    <Link href={`/${username}/collections`} {...linkProps}>
                        View all icon sets
                    </Link>
                </LinkContainer>
            </header>

            <div className="col-xs-12">
                <CollectionList collections={collections} />
            </div>
        </React.Fragment>
    );
};

const DashboardCollectionSection = ({ showIcons, collections, username }) => {
    if (showIcons) {
        return (
            <section
                id="user-collections"
                className="profile-section container row"
            >
                <div className="container row">
                    {collections && collections.length ? (
                        <Collection
                            username={username}
                            collections={collections}
                        />
                    ) : (
                        <React.Fragment>
                            <header className="display-flex col-xs-12">
                                <h3 className="ui_collections">Icon Sets</h3>
                            </header>
                            <a
                                className="upload-new light ui_plus-circle-no-fill"
                                href="/upload"
                            >
                                Upload an icon set
                            </a>
                        </React.Fragment>
                    )}
                </div>
            </section>
        );
    }

    return null;
};

export default DashboardCollectionSection;
